export default __webpack_public_path__ + "static/media/Icons-34.967c39e1.png";